import OrDivider from "components/common/Auth/OrDivider";
import { Navbar } from "@/components/modules/Navigation/Navbar/Navbar";
import { commonLanguageFiles } from "@/config";
import { LanguageProvider } from "@/contexts/LanguageProvider";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import GoogleAuthButton from "components/common/Auth/GoogleAuthButton";
import DontHaveAnAccount from "components/common/Auth/DontHaveAnAccount";
import LoginForm from "components/modules/Auth/Login/LoginForm";
import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";
import { translate } from "components/common/Translate/Translate";

const LoginPage = () => {
    return (
        <div className="w-full text-black max-w-1440 page-shadow dark:text-white min-h-screen flex flex-col">
            <Navbar url={"/auth/login"} />
            <div className="flex-1 flex items-center justify-center">
                <div className="w-full max-w-[24rem] p-8 space-y-6 bg-white dark:bg-darkSurface-100 shadow-[0_0_30px_rgba(0,0,0,0.1)] rounded-lg">
                    <h2 className="text-2xl font-bold text-center text-gray-700 dark:text-white mb-4">
                        {translate("page-title")}
                    </h2>
                    <ReduxProvider>
                        <LoginForm />
                    </ReduxProvider>
                    <OrDivider />
                    <GoogleAuthButton />
                    <DontHaveAnAccount />
                </div>
            </div>
        </div>
    );
};

const LanguageWrapper = () => {
    return (
        <LanguageProvider files={files}>
            <LoginPage />
        </LanguageProvider>
    );
};

export default LanguageWrapper;

const files = ["login", "auth", ...commonLanguageFiles];

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    return {
        props: {
            ...(await serverSideTranslations(locale ?? "", files)),
        },
    };
};
